export function CalculatorResultCard({
  label,
  value,
  sub,
  accent,
  large,
}: {
  label: string
  value: string
  sub?: string
  accent?: boolean
  large?: boolean
}) {
  return (
    <div
      className={`rounded-xl border p-5 ${accent ? "border-red/20 bg-red/[0.03]" : "border-stone bg-white"}`}
    >
      <p className="text-xs font-medium uppercase tracking-[0.15em] text-warm-grey">
        {label}
      </p>
      <p
        className={`mt-1 font-display font-bold tracking-tight ${
          large ? "text-3xl md:text-4xl" : "text-2xl"
        } ${accent ? "text-red" : "text-charcoal"}`}
      >
        {value}
      </p>
      {sub && <p className="mt-0.5 text-xs text-warm-grey">{sub}</p>}
    </div>
  )
}
